<template>
  <div class="btns">
    <button class="cancel" v-if="cancelbtn" @click="$emit('cancel')">取消</button>
    <button class="confirm" @click="$emit('confirm')">{{confirmLabel}}</button>
  </div>
</template>

<script>
export default {
  props: {
    confirmLabel: {
      type: String,
      default: '儲存'
    },
    cancelbtn: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
</style>
